export const HUDDLE_LEADERBOARD_COLUMNS = [
  { key: 'rank', label: 'Rank', sortable: true },
  { key: 'name', label: 'Name', sortable: true },
  { key: 'role', label: 'Role', sortable: true },
  {
    key: 'productionCollected',
    label: 'Production collected',
    sortable: true,
  },
]
